import {useQuery} from '@apollo/client';
import {useBuilderContext} from '../CreateBuilder/useBuilderContext';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';
import {sanitiseProductType} from '../../../utils/sanitiseProductType';
import validateUUID from '../../../utils/validateUUID';
import {BUILDER_MODIFY_POTS} from '../builderPotQueries';
import {reccNonEditable} from '../CreateBuilder/BuilderSourceDestination/CreateBuilderFooter';
import {builderFieldsType} from '../CreateBuilder/builderFields';
import {BuilderPot} from '../../../schema-types/BuilderPot';
import {
  BuilderModifyPots,
  BuilderModifyPotsVariables,
} from '../../../schema-types/BuilderModifyPots';
import {modifySources} from '../hooks/builderModifyHooks';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';

export const useModifyPotsQuery = (): {sourcePots: BuilderPot[]} => {
  const {builderDetails, builderReviewId} = useBuilderContext();
  const {values} = useAutoForm<builderFieldsType>();
  const contactId = values.contact ? validateUUID(values.contact) || null : null;
  const isNonEditable = !!reccNonEditable(builderDetails);

  const {data: potsData} = useQuery<BuilderModifyPots, BuilderModifyPotsVariables>(
    BUILDER_MODIFY_POTS,
    {
      variables: {
        reviewId: validateUUID(builderReviewId)!,
        contactId,
        potType: sanitiseProductType(values.mainPlanType) ?? '',
      },
      skip:
        isNonEditable ||
        values.planAction !== OVRecommendActionEnum.MODIFY ||
        !values.mainPlanType ||
        !validateUUID(builderReviewId),
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    }
  );

  if (isNonEditable) {
    const savedPot = builderDetails?.modify?.pot;
    return {
      sourcePots: modifySources(savedPot ? [savedPot] : []),
    };
  }

  return {
    sourcePots: modifySources(potsData?.modifyPots?.sources ?? []),
  };
};
